import { StoreState } from "..";

export const getFlexibleDateMinPrice = (state: StoreState) => state.flexibleDateMinPrice.flexibleDateMinPrice || [];
